type ChevronType = {
  className?: string;
  rotate?: number;
};
const Chevron = ({ className = '', rotate = 0 }: ChevronType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 29"
    fill="none"
    transform={`rotate(${rotate})`}
    style={{ transition: 'transform 0.5s ease' }}
    className={className}
  >
    <path
      d="M14 19.2234C14.3076 19.2146 14.5889 19.1003 14.8174 18.8542L21.4971 12.0164C21.6904 11.823 21.7959 11.5769 21.7959 11.2869C21.7959 10.7068 21.3389 10.241 20.7588 10.241C20.4775 10.241 20.2051 10.3552 20.0029 10.5574L14.0088 16.7185L7.99707 10.5574C7.79492 10.364 7.53125 10.241 7.24121 10.241C6.66113 10.241 6.2041 10.7068 6.2041 11.2869C6.2041 11.5769 6.30957 11.823 6.50293 12.0164L13.1914 18.8542C13.4287 19.1003 13.6924 19.2234 14 19.2234Z"
      fill="#1C1C1E"
    />
  </svg>
);

export default Chevron;
